import React, { useRef } from 'react';
import Button from '../Button';
import Dots from '../../../assets/icons/dots';
import { Option, Options, StyledDiv, StyledSpan } from './styles';
import { useOutsideDrop } from '../../../hooks/useOutsideDrop';

const DropdownSelection = ({ options = [], actived, setActived }) => {
  const containerRef = useRef(null);

  useOutsideDrop(containerRef, () => setActived(false));

  return (
    <StyledDiv ref={containerRef}>
      <Button
        round
        width="1.3125rem"
        height="1.3125rem"
        iconSize="0.764583333rem"
        Icon={() => (
          <Dots
            color={actived ? '#EFF1F5' : '#232323'}
            style={{
              pointerEvents: 'none', // Disable pointer events on the icon
            }}
          />
        )}
        background={actived ? '#585E66' : 'transparent'}
        activeBackground={actived ? '#585E66' : '#D4D6DA'}
        onClick={(e) => {
          setActived(!actived);
        }}
      />
      <Options actived={actived}>
        {options.map((item, index) => (
          <Option key={index} onClick={() => item.onClick()} actived={actived}>
            <StyledSpan actived={actived}>{item.label}</StyledSpan>
          </Option>
        ))}
      </Options>
    </StyledDiv>
  );
};

export default DropdownSelection;
